import { Dispatch } from 'react';
import { getQueryPath } from 'src/app/common/utils';
import { PaginateList } from 'src/app/common/types';
import { apiClient, apiErrorHandler, ADMIN_URL } from 'src/app/common/network';
import { CreateUpdateContractSettingBody, ContractSettingItem } from '../types/contract-setting-types';
import { AnyAction } from 'redux';

export type ContractSettingListParam = {
  page: number;
  limit: number;
  sort?: string;
  productName?: string;
};

const urlEndPoint = `${ADMIN_URL}/commission/contract`;

export const fetchContractSettingList = async (
  params: ContractSettingListParam,
  dispatch?: Dispatch<AnyAction>,
): Promise<PaginateList<ContractSettingItem>> => {
  const queryPath = getQueryPath(`${urlEndPoint}?`, params);
  return apiClient
    .get<PaginateList<ContractSettingItem>>(queryPath)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchContractSettingItem = async (
  id: string,
  dispatch?: Dispatch<AnyAction>,
): Promise<ContractSettingItem> =>
  apiClient
    .get<ContractSettingItem>(`${urlEndPoint}/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });

export const createContractSettingItem = async (
  body: CreateUpdateContractSettingBody,
  dispatch?: Dispatch<AnyAction>,
): Promise<void> =>
  apiClient
    .post<void>(`${urlEndPoint}`, body)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });

export const modifyContractSettingItem = async (
  id: string,
  body: CreateUpdateContractSettingBody,
  dispatch?: Dispatch<AnyAction>,
): Promise<void> =>
  apiClient
    .put<void>(`${urlEndPoint}/${id}`, body)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });

export const deleteContractSettingItem = async (id: string, dispatch?: Dispatch<AnyAction>): Promise<void> =>
  apiClient
    .delete<void>(`${urlEndPoint}/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });

export const importContractSettingCsv = async (file: File, dispatch?: Dispatch<AnyAction>): Promise<void> => {
  const formData = new FormData();
  formData.append('file', file);

  return apiClient
    .post<void>(`${urlEndPoint}/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
